module.exports = __webpack_public_path__ + "img/Pakistan.9c278221.svg";